import React from "react";
import {NewOfferingComponent} from "../../components/home/new-offering";
import {DashboardWrapper} from "../../layouts/dashboard-wrapper";

function NewOfferingPage() {
  return (
    <>
      <DashboardWrapper
        pageTitle="New Offering"
        pageDesc="Create or manage a new offering"
        pageSlug="/new-offering"
      >
        <NewOfferingComponent />
      </DashboardWrapper>
    </>
  );
}

export default NewOfferingPage;
